import { defineMessages } from 'react-intl-next';

const messages = defineMessages({
	saveViewError: {
		id: 'eoc.escalation-policy.flag.save-view-error.no-translate',
		defaultMessage: `We couldn't save the view preferences`,
		description:
			'Title of error message that will be displayed in the flag if something went wrong while saving the view preferences',
	},
	refresh: {
		id: 'eoc.escalation-policy.flag.refresh.no-translate',
		defaultMessage: `Refresh`,
		description: 'Label of first action button inside flag',
	},
});

export default messages;
